// Banner Slider
$(function(){
  $('.banner-slider').slick({
      dots: true,
      arrows: true, 
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1100, 
      fade: true,
      cssEase: 'ease-out',
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipe: true,
      touchMove: false,  
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: false, 
          }
        }
      ]
  });
});

// Featured Products Slider
$(function(){
  $('.featured_products .resource-list').slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3100,
      speed: 1440,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
          {breakpoint: 1025, settings: {slidesToShow: 3, slidesToScroll: 2}},
          {breakpoint: 750, settings: {slidesToShow: 1, slidesToScroll: 1}}
      ]
  });
});

// Trust Slider
$(function(){
  $('.trustbar-wrapper .trust-bar').slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3100,
      speed: 1440,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      slidesToShow: 5,
      slidesToScroll: 3,
      responsive: [
          {breakpoint: 1025, settings: {slidesToShow: 4, slidesToScroll: 2}},
          {breakpoint: 990, settings: {slidesToShow: 3, slidesToScroll: 2}},
          {breakpoint: 750, settings: {slidesToShow: 2, slidesToScroll: 2}}
      ]
  });
});

// Whitespace 
document.querySelectorAll('.tab-content p, .short-description p').forEach(p => {
  if (p.textContent.trim() === '') {
    p.style.display = 'none';
  }
});


// Filter Position
document.querySelectorAll('.facets--horizontal .facets__item').forEach(item => {
  const label = item.querySelector('.facets__label');
  const panel = item.querySelector('.facets__panel-content');
  if (!label || !panel) return;

  const width = label.offsetWidth;
  panel.style.marginLeft = `calc(${width}px + 1.1rem)`;
});

// Colspan of Th
document.addEventListener('DOMContentLoaded', function () {
  const tables = document.querySelectorAll(
    '.tab-section .tab-content table'
  );

  tables.forEach(table => {
    const rows = table.querySelectorAll('tr');

    // STEP 1: find max column count in table
    let maxColumns = 0;

    rows.forEach(row => {
      const cells = row.querySelectorAll('td, th');
      if (cells.length > maxColumns) {
        maxColumns = cells.length;
      }
    });

    // STEP 2: apply colspan where first td is empty
    rows.forEach(row => {
      const th = row.querySelector('th');
      if (!th) return;

      const firstTd = row.querySelector('td');
      if (!firstTd) return;

      if (firstTd.textContent.trim() === '') {
        firstTd.style.display = 'none';
        th.setAttribute('colspan', maxColumns);
      }
    });
  });
});

// Read More
jQuery(document).on('click', '.button.show', function (e) {
  e.preventDefault();
  var $btn = jQuery(this);
  var $content = $btn.prev('.show-content');
  $content.slideToggle(300, function () {
    $btn.text($content.is(':visible') ? 'Read Less' : 'Read More');
  });
});


// Sticky Header
jQuery(document).ready(function() {
	jQuery(window).scroll(function() {
	var sticky = jQuery('.header'),
	scroll = jQuery(window).scrollTop();
	if (scroll >= 100) sticky.addClass('fixed');
	else sticky.removeClass('fixed');
	});
});

// ====
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector('.go-to-cart-btn');
  if (!btn) return;
  function getCurrentVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? parseInt(input.value) : null;
  }
  function updateButtonVisibility() {
    const variantId = getCurrentVariantId();
    if (!variantId) return;
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const inCart = cart.items.some(item => item.variant_id === variantId);
        btn.style.display = inCart ? 'flex' : 'none';
      });
  }
  window.addEventListener('load', updateButtonVisibility);
  document.addEventListener('change', function(e){
    if(e.target.name === 'id'){
      setTimeout(updateButtonVisibility, 300);
    }
  });
  const originalFetch = window.fetch;
  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    if (typeof arguments[0] === 'string' && arguments[0].includes('/cart')) {
      setTimeout(updateButtonVisibility, 400);
    }
    return response;
  };
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    this.addEventListener('load', function () {
      if (this.responseURL.includes('/cart')) {
        setTimeout(updateButtonVisibility, 400);
      }
    });
    open.apply(this, arguments);
  };
});
